import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import responsiveStyles from "./responsiveStyles.module.scss";
import { Wrapper } from "../../reusable";
import { CardStack } from "../../ui/card-stack";

import shieldTick from "../../../assets/shieldtick.svg";
import noWinNoFee from "../../../assets/nowinnofee.svg";
import excellentTrack from "../../../assets/excellent-track-record.svg";

function ReasonsToSignUp() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const cards = [
    {
      id: 1,
      name: "Expert Legal Support",
      designation: "Professional",
      content: (
        <div>
          <div
            style={{
              height: "44px",
              width: "44px",
              borderRadius: "12px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f4faff",
              border: "1px solid #e4f0fb",
              marginBottom: "12px",
            }}
          >
            <img
              src={shieldTick}
              alt="Expert legal support"
              style={{ height: "24px" }}
            />
          </div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            Expert Legal Support
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            Specialist teams handle your claim end‑to‑end, with clear guidance.
          </p>
        </div>
      ),
    },
    {
      id: 2,
      name: "No Win, No Fee",
      designation: "Risk-free",
      content: (
        <div>
          <div
            style={{
              height: "44px",
              width: "44px",
              borderRadius: "12px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f4faff",
              border: "1px solid #e4f0fb",
              marginBottom: "12px",
            }}
          >
            <img
              src={noWinNoFee}
              alt="No win no fee"
              style={{ height: "24px" }}
            />
          </div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            No Win, No Fee
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            We only get paid when you do. Zero upfront costs to get started.
          </p>
        </div>
      ),
    },
    {
      id: 3,
      name: "Excellent Track Record",
      designation: "Proven success",
      content: (
        <div>
          <div
            style={{
              height: "44px",
              width: "44px",
              borderRadius: "12px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f4faff",
              border: "1px solid #e4f0fb",
              marginBottom: "12px",
            }}
          >
            <img
              src={excellentTrack}
              alt="Excellent track record"
              style={{ height: "24px" }}
            />
          </div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            Excellent Track Record
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            Thousands supported with fair outcomes and swift resolutions.
          </p>
        </div>
      ),
    },
  ];

  return (
    <section
      className={`${styles.reasonsToSignUp} ${responsiveStyles.reasonsToSignUp}`}
    >
      <Wrapper>
        <div className={styles.container}>
          <div className={styles.header}>
            <h2>Reasons to Sign Up</h2>
            <div className={styles.statPills}>
              <span>98% Satisfaction</span>
              <span>10k+ Claims Assisted</span>
              <span>Fast, Secure, Trusted</span>
            </div>
          </div>

          {/* Desktop: Show original card layout */}
          <div
            className={`${styles.cardsScroller} ${responsiveStyles.cardsScroller}`}
            style={{ display: isMobile ? "none" : "grid" }}
          >
            <article className={styles.card}>
              <div className={styles.iconWrap}>
                <img src={shieldTick} alt="Expert legal support" />
              </div>
              <h3>Expert Legal Support</h3>
              <p>
                Specialist teams handle your claim end‑to‑end, with clear
                guidance.
              </p>
            </article>

            <article className={styles.card}>
              <div className={styles.iconWrap}>
                <img src={noWinNoFee} alt="No win no fee" />
              </div>
              <h3>No Win, No Fee</h3>
              <p>
                We only get paid when you do. Zero upfront costs to get started.
              </p>
            </article>

            <article className={styles.card}>
              <div className={styles.iconWrap}>
                <img src={excellentTrack} alt="Excellent track record" />
              </div>
              <h3>Excellent Track Record</h3>
              <p>
                Thousands supported with fair outcomes and swift resolutions.
              </p>
            </article>
          </div>

          {/* Mobile: Show CardStack */}
          {isMobile && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "calc(100% + 40px)",
                marginLeft: "-20px",
                marginRight: "-20px",
                marginTop: "40px",
              }}
            >
              <CardStack items={cards} offset={15} scaleFactor={0.08} />
            </div>
          )}
        </div>
      </Wrapper>
    </section>
  );
}

export default ReasonsToSignUp;
